import { ref, watch } from 'vue';
import { defineStore } from 'pinia';

const STORAGE_KEY = 'preferences';

function loadFromStorage(fallback) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

const DEFAULT_PEOPLE_FILTERS = Object.freeze({
  dir: 'desc',
  sort: 'updated_at',
  page: 1,
  search: '',
  type: '',
  hideSharedWithMe: false,
  onlyHouseholds: false,
});

export const usePreferencesStore = defineStore('preferences', () => {
  const collapseSideNav = ref(false);
  const peopleFilters = ref({ ...DEFAULT_PEOPLE_FILTERS });

  const stored = loadFromStorage({
    collapseSideNav: false,
    peopleFilters: DEFAULT_PEOPLE_FILTERS,
  });

  collapseSideNav.value = stored.collapseSideNav;
  peopleFilters.value = {
    ...DEFAULT_PEOPLE_FILTERS,
    ...stored.peopleFilters,
  };

  watch(
      [collapseSideNav, peopleFilters],
      ([collapseSideNav, peopleFilters]) => {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ collapseSideNav, peopleFilters }),
        );
      },
      { deep: true },
  );

  function resetPeopleFilters() {
    Object.assign(peopleFilters.value, DEFAULT_PEOPLE_FILTERS);
  }

  return {
    collapseSideNav,
    peopleFilters,
    resetPeopleFilters,
  };
});
